
export default {
  data() {
    return {
      menu: [
        {
          text: 'Home',
          disabled: !1,
          to: '/'
        },
        {
          text: 'Horário de Atendimento',
          disabled: !0,
          to: '/horario'
        }
      ],
      days: [
        { day: 1, name: 'segunda-feira', status: !1, times: [] },
        { day: 2, name: 'terça-feira', status: !1, times: [] },
        { day: 3, name: 'quarta-feira', status: !1, times: [] },
        { day: 4, name: 'quinta-feira', status: !1, times: [] },
        { day: 5, name: 'sexta-feira', status: !1, times: [] },
        { day: 6, name: 'sábado', status: !1, times: [] },
        { day: 0, name: 'domingo', status: !1, times: [] }
      ],
      list: []
    }
  },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 170,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 170
      else if (sm) size = 190
      else if (mdAndUp) size = 270
      return size
    }
  },
  async created() {
    const vm = this,
      days = vm.days,
      r = await axios.get('app/hours')
    days.filter((item) => {
      let { day, name, status } = item,
        add = !1
      const _times = []
      r.filter((t) => {
        if (day.toString() === t.day.toString()) {
          _times.push({
            start: t.start,
            end: t.end,
            error: '',
            remove: !0
          })
        }
      })
      status = _times.length > 0
      if (_times.length > 0) {
        if (_times.length === 1) {
          _times[0].remove = !1
        }
        add = !0
      }
      vm.list.push({ day, name, times: _times, add, status })
    })
  }
}
